import React, { ReactNode, useCallback } from 'react';
import MUIStepper from '@mui/material/Stepper';
import {
  Step,
  StepConnector,
  stepConnectorClasses,
  StepContent,
  StepIconProps,
  StepLabel,
  styled,
  Typography,
} from '@mui/material';
import { Check } from '@mui/icons-material';
import { Box } from '@mui/system';

interface Step {
  id: string;
  label: ReactNode;
  content: ReactNode;
  isCompleted?: boolean;
}

interface IProps {
  steps: Step[];
  activeStep: number;
  Icon?: React.FC<any>;
}

const StepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(({ ownerState }) => ({
  display: 'flex',
  alignItems: 'center',
  width: 16,
  height: 16,
  top: '-20px',
  borderRadius: '50%',
  ...(ownerState.active && {
    boxSizing: 'border-box',
    border: '4px solid #000',
    width: 18,
    height: 18,
  }),
  '& .StepIcon-completedIcon': {
    color: 'white',
    zIndex: 1,
    border: '1px solid #000',
    background: '#000',
    borderRadius: '50%',
    width: 16,
    height: 16,
  },
  '& .StepIcon-circle': {
    backgroundColor: 'white',
    border: '1px solid grey',
    width: 16,
    borderRadius: '50%',
    height: 14,
    ...(ownerState.active && {
      border: 'none',
      width: 0,
      height: 0,
    }),
  },
  '& .line': {
    top: '30%',
    left: 8,
    height: '100%',
    position: 'absolute',
    borderLeft: '4px solid #000',
  },
}));

const Connector = styled(StepConnector)(() => ({
  marginLeft: 7,
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 7,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#000',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#000',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderLeft: '4px solid #000',
  },
}));

const StepperVertical: React.FC<IProps> = ({ steps, activeStep, Icon }) => {
  const StepIcon: React.FC<any> = useCallback(
    ({ active, className, completed }) => {
      return (
        <StepIconRoot ownerState={{ active }} className={className}>
          {completed ? (
            (() => {
              return Icon ? <Icon className="StepIcon-completedIcon" /> : <Check className="StepIcon-completedIcon" />;
            })()
          ) : (
            <div className="StepIcon-circle" />
          )}
        </StepIconRoot>
      );
    },
    [Icon]
  );

  return (
    <MUIStepper activeStep={activeStep} connector={null} orientation="vertical" sx={{ marginTop: '15px' }}>
      {Array.isArray(steps) &&
        steps.map((step, index) => {
          console.log(step, 'step');
          return (
            <Step key={step.id} expanded>
              {step.label && (
                <StepLabel
                  StepIconComponent={() => StepIcon({ completed: step?.isCompleted })}
                  sx={{ position: 'relative', alignItems: 'flex-start', padding: '0' }}
                >
                  {step.label}
                </StepLabel>
              )}
              <StepContent
                sx={{
                  marginLeft: '7px',
                  borderLeft: index === steps.length - 1 ? '' : `4px solid ${step?.isCompleted ? '#000' : 'grey'} `,
                  paddingTop: '5px',
                  paddingBottom: '5px',
                  paddingLeft: '25px',
                  minHeight: '15px',
                }}
              >
                {step.content}
              </StepContent>
              {/* <StepContent sx={{ borderLeft: '4px solid #000', marginLeft: '7px', paddingLeft: '24px' }}>
                <Typography fontSize={14} color="#1F1F1F" lineHeight="19px" variant="caption" component="div">
                  Sep 24, 2022 - Detailing end date
                </Typography>
                <Box sx={{ borderLeft: '2px solid #dbd4c5', paddingLeft: '15px' }} marginTop={2.5}>
                  <Typography variant="h5" fontSize={12} fontWeight={500} paddingBottom="3px">
                    On hold - Parts
                  </Typography>
                  <Typography fontSize={12} fontWeight={500} color="#40423F">
                    Sep 13, 2022 - On hold end date
                  </Typography>
                  <Typography fontSize={12} fontWeight={500} color="#40423F">
                    Sep 13, 2022 - Part received date
                  </Typography>
                  <Typography fontSize={12} fontWeight={500} color="#40423F">
                    Sep 12, 2022 - Part ordered date
                  </Typography>
                  <Typography fontSize={12} fontWeight={500} color="#40423F">
                    Sep 12, 2022 - On hold start date
                  </Typography>
                </Box>
              </StepContent> */}
            </Step>
          );
        })}
    </MUIStepper>
  );
};

export default StepperVertical;
